// Header card of the case brief. Moved out of CaseBriefPage.js (ticket 072). The referral-only
// rows (email, phone, Pipeline, Assigned, Refresh) stay conditional so ticket 074 can add a variant.
import React from 'react'
import { EmailDisplay, PhoneDisplay } from './ContactDisplay'
import { formatDate, formatDateTime, statusLabel } from '../../../lib/briefFormat'

export function CaseHeader({ header, generatedAt, onRegenerate, regenerating }) {
  return (
    <div className="brief-header">
      <div className="brief-header-top">
        <div>
          <h1 className="brief-header-name">{header.name}</h1>
          <div className="u-row-md">
            {header.email && <EmailDisplay email={header.email} />}
            {header.phone && <PhoneDisplay phone={header.phone} />}
          </div>
        </div>
        <div className="brief-header-right">
          <div className="brief-header-right-row">
            <span className="brief-header-right-label">Pipeline:</span>
            {statusLabel(header.leadStatus)}
          </div>
          <div className="brief-header-right-row">
            <span className="brief-header-right-label">Assigned:</span>
            {formatDate(header.assignedAt)}
          </div>
        </div>
      </div>

      <div className="brief-summary-grid">
        {header.summaryRows.map(({ label, value }) => (
          <React.Fragment key={label}>
            <div className="brief-summary-label">{label}</div>
            <div className="brief-summary-value">{value}</div>
          </React.Fragment>
        ))}
      </div>

      {header.footerLine ? (
        // Saved intake: nothing to refresh, a plain line instead (ticket 072, D7).
        <div className="brief-header-footer-row">
          <span className="brief-header-right-row brief-header-generated">{header.footerLine}</span>
        </div>
      ) : (
        <div className="brief-header-footer-row">
          <span className="brief-header-right-row brief-header-generated">
            Refreshed {formatDateTime(generatedAt)}
          </span>
          <button className="brief-regen-btn" onClick={onRegenerate} disabled={regenerating}>
            {regenerating ? 'Refreshing…' : '↺ Refresh'}
          </button>
        </div>
      )}
    </div>
  )
}
